module.exports = __webpack_public_path__ + "static/media/teams-icon.b0b2d9f4.png";